import { Link, useSearchParams } from "react-router-dom";
import Search from "../Search/Search";
import { useCallback, useEffect, useState } from "react";
import { DictionaryItem } from "../../DictionaryPage/DictionaryPage";
import api from "../../../../api/axiosInstance";

const SideMenu = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleFilterChange = (e: any) => {
    if (searchParams.get("sort") !== e.target.value) {
      setSearchParams({
        ...Object.fromEntries(searchParams.entries()),
        sort: e.target.value,
      });
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [searchParams]);

  const [categories, setCategories] = useState<DictionaryItem[]>([]);

  const fetchCategories = useCallback(async () => {
    const response = await api.get(`Dictionary/Category`);
    setCategories(response.data);
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return (
    <div
      className="px-4 h-max sticky top-8"
      style={{
        minWidth: "10rem",
      }}
    >
      <h1 className="mb-4 text-sm font-medium">
        <b>ძებნა</b>
      </h1>
      <Search />
      <h1 className="mt-8 mb-4 text-sm font-medium">
        <b>კატეგორიები</b>
      </h1>
      <div className="flex flex-col gap-2 text-sm">
        <Link
          to="/blog/posts"
          className={`underline ${
            !searchParams.get("category") ? "text-blue-800 font-semibold" : ""
          }`}
        >
          ყველა კატეგორია
        </Link>
        {categories.map((category) => (
          <Link
            key={category.id}
            to={{
              pathname: "/blog/posts",
              search: `?${new URLSearchParams({
                ...Object.fromEntries(searchParams.entries()),
                category: category.categoryName,
              }).toString()}`,
            }}
            className={`underline ${
              searchParams.get("category") === category.categoryName
                ? "text-blue-800 font-semibold"
                : ""
            }`}
          >
            {category.categoryName}
          </Link>
        ))}
      </div>
      <button
        onClick={() => setSearchParams({})}
        className="mt-8 text-sm text-red-600 underline"
      >
        ფილტრების წაშლა
      </button>
    </div>
  );
};

export default SideMenu;
